/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2018 Deere & Company

import './index.scss';
import AmountOfUseModal from './amount-of-use-modal';
import { FormattedMessage } from 'react-intl';
import LabeledString from '../labeled-string';
import MeasurementReading from '../../state/measurement-reading';
import PropTypes from 'prop-types';
import React from 'react';
import { buildProductUseAmount } from '../../services/product';

const AmountOfUseWithModal = (props) => (
    <div className="amount-of-use-with-modal">
        {props.measurementReadings.length > 0 && (
            <div>
                <div className="amount-of-use">
                    <LabeledString
                        className="use-amount-last-updated"
                        data={buildProductUseAmount(props.measurementReadings[0].useAmount, props.measurementReadings[0].date)}
                        label="AMOUNT_OF_USE"
                    />
                    {props.measurementReadings.length > 1 && (
                        <span
                            className="open-use-amount-modal-link"
                            onClick={props.onAmountOfUseModalOpen}
                        >
                            <FormattedMessage id="MORE" />
                        </span>
                    )}
                </div>
                <AmountOfUseModal
                    isModalOpen={props.isAmountOfUseModalOpen}
                    measurementReadings={props.measurementReadings}
                    onCloseButtonClick={props.onAmountOfUseModalClose}
                />
            </div>
        )}
    </div>
);

AmountOfUseWithModal.displayName = 'AmountOfUseWithModal';
AmountOfUseWithModal.propTypes = {
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onAmountOfUseModalClose: PropTypes.func.isRequired,
    onAmountOfUseModalOpen: PropTypes.func.isRequired,
};

export default AmountOfUseWithModal;
